// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"ef871881","498":"689bd350","703":"b541d5cd","787":"f107d19a"}[chunkId] + ".chunk.js";
};